


































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-shopping-cart-continue-shopping',
  components: {},
})
export default class ShoppingCartContinueShopping extends Vue {
  get BookingsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.BOOKINGS_MODULE_NAME);
  }
  get ActivitiesModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACTIVITIES_MODULE_NAME);
  }
  get SubscriptionsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.SUBSCRIPTIONS_MODULE_NAME);
  }
}
